import React, { useEffect, useState } from "react";
import PageLoader from "../../common/pageLoader";
import ToBeRegisteredComponent from "./toBeRegistered";
import { unregisteredFlats } from "../../../../redux/slice/unregisteredFlatsSlice";
import { Cookies } from "react-cookie";
import { connect } from "react-redux";
import { Tag } from "antd";
import { societyWingList } from "../../../../redux/slice/societyWingListSlice";
import { exportUnregisteredFlatList } from "../../../../redux/slice/exportUnregisteredFlatListSlice";
import Notify from "../../common/notify/notify";

const ToBeRegistered = (props) => {
  const {
    unregisteredFlatsData,
    callunregisteredFlatsData,
    callsocietyWingListData,
    societyWingListData,
    callexportUnregisteredFlatListData,
  } = props;

  const cookies = new Cookies();
  const id = cookies.get("societyId");

  const loading = societyWingListData?.loading;

  const [selectedWingId, setSelectedWingId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const wingList = societyWingListData?.societyWingListData?.data?.data || [];
  const unregisteredFlatsList =
    unregisteredFlatsData?.unregisteredFlatsData?.data?.data || [];

  useEffect(() => {
    if (id) {
      callunregisteredFlatsData(id);
      callsocietyWingListData(id);
    }
  }, [id]);

  useEffect(() => {
    if (unregisteredFlatsList) {
      setFilteredData(unregisteredFlatsList);
    }
  }, [unregisteredFlatsList]);

  useEffect(() => {
    const filtered = unregisteredFlatsList?.filter((flat) => {
      const matchesWing = selectedWingId
        ? flat.wing_id === selectedWingId
        : true;
      return matchesWing;
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [selectedWingId, unregisteredFlatsList]);

  const handleWingChange = (value) => {
    setSelectedWingId(value);
  };

  const handleClearFilters = () => {
    setSelectedWingId(null);
    setFilteredData(unregisteredFlatsList);
    setCurrentPage(1);
  };

  const isClearDisabled = !selectedWingId;

  const user_table_columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Wing Name",
      dataIndex: "wing_name",
      key: "wing_name",
    },
    {
      title: "Flat Number",
      dataIndex: "flat_number",
      key: "flat_number",
    },
    {
      title: "Status",
      key: "status",
      render: () => <Tag color="volcano">Unregistered</Tag>,
    },
  ];

  const handleExportData = async () => {
    try {
      const exportResult = await callexportUnregisteredFlatListData(id);

      if (exportResult.type === "exportUnregisteredFlatList/fulfilled") {
        if (exportResult.payload.message) {
          Notify("success", exportResult.payload.message, "");
          return;
        }

        const csvBlob = new Blob([exportResult.payload.data], {
          type: "text/csv",
        });
        const url = window.URL.createObjectURL(csvBlob);
        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", "unregistered_flats.csv");
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
      } else {
        Notify("error", exportResult.error.message, "");
      }
    } catch (error) {
      Notify("error", "Oops! Something went wrong. Please try again later.", "");
    }
  };

  return (
    <>
      {loading && <PageLoader />}
      <ToBeRegisteredComponent
        unregisteredFlatsList={unregisteredFlatsList}
        user_table_columns={user_table_columns}
        handleClearFilters={handleClearFilters}
        filteredData={filteredData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        handleWingChange={handleWingChange}
        selectedWingId={selectedWingId}
        wingList={wingList}
        handleExportData={handleExportData}
        isClearDisabled={isClearDisabled}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  unregisteredFlatsData: state.unregisteredFlats,
  societyWingListData: state.societyWingListData,
  exportUnregisteredFlatListData: state.exportUnregisteredFlatList,
});

const mapDispatchToProps = (dispatch) => ({
  callunregisteredFlatsData: (data) => dispatch(unregisteredFlats(data)),
  callsocietyWingListData: (data) => dispatch(societyWingList(data)),
  callexportUnregisteredFlatListData: (data) =>
    dispatch(exportUnregisteredFlatList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToBeRegistered);
